import { axiosInstance } from "../../utility/apiInstance";
import { AirRules, AWBArchivalRuleData, OceanArchivalRuleData, OceanRules, Shipment, Statistics } from "./type-model";


export const DEFAULT_AIR_RULES: AirRules = {
    _id: undefined,
    inactive: 7,
    arrival: 2,
    delivered: 2,
};

export const DEFAULT_OCEAN_RULES: OceanRules = {
    _id: undefined,
    inactive: 15,
    gateOut: 15,
    containerReturn: 15,
};


export const DEFAULT_STATISTICS: Statistics = {
    totalArchived: 0,
    lastMonth: 0,
    avgDaysToArchive: 0,
};
export const mapAirResponse = (data: AWBArchivalRuleData) => {
    return {
        _id: data._id,
        inactive: data.daysAfterInactive,
        arrival: data.daysAfterArrival,
        delivered: data.daysAfterDelivered
    };
}
export const mapOceanResponse = (data: OceanArchivalRuleData) => {
    return {
        _id: data._id,
        inactive: data.daysAfterInactive,
        gateOut: data.daysAfterGateOut,
        containerReturn: data.daysAfterContainerReturn
    };
}
export const fetchOceanRule = async () => {
    try {
        const { data } = await axiosInstance.get(
            "/api/v1/ocean-archival-rule"
        );
        return mapOceanResponse(data?.data);
    } catch (error: any) {
        if (error.response?.status === 404) {
            return DEFAULT_OCEAN_RULES;
        } else {
            throw error;
        }
    }
};


export const fetchAWBRule = async () => {
    try {
        const { data } = await axiosInstance.get(
            "/api/v1/archival-rules"
        );

        return mapAirResponse(data?.data);
    } catch (error: any) {
        if (error.response?.status === 404) {
            return DEFAULT_AIR_RULES;
        } else {
            throw error;
        }
    }
};


export const fetchAirArchiveStats = async (url: string): Promise<Statistics> => {
    try {
        const response = await axiosInstance.get(url);

        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch archive stats");
        }

        return response.data.data;
    } catch (error: any) {
        throw error;
    }
};


export const fetchArchieveShipments = async (
    url: string,
    queryParams?: Record<string, any>
): Promise<Shipment[]> => {
    try {
        const response = await axiosInstance.get(url, {
            params: queryParams,
        });

        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch archive stats");
        }

        return response.data.data;
    } catch (error: any) {
        throw error;
    }
};
export const fetchOGeneralApi = async (
    url: string,
    queryParams?: Record<string, any>
): Promise<string[]> => {
    try {
        const response = await axiosInstance.get(url, {
            params: queryParams,
        });

        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch archive stats");
        }

        return response.data.data;
    } catch (error: any) {
        throw error;
    }
};



export const validateRules = (
  rules: AirRules | OceanRules,
  fields: string[]
): string | null => {
  for (const field of fields) {
    const value = (rules as any)[field];

    if (typeof value !== 'number' || value <= 0) {
      return `Day after ${field.replace(/([A-Z])/g, ' $1')} must be greater than 0`;
    }
  }
  return null;
};
